import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { CustomerModel } from 'src/app/models/customer-model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UniqueIDService } from 'src/app/services/unique-id/unique-id.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from "src/app/services/routing/navigator";

@Component({
  selector: 'app-authenticator-sms',
  templateUrl: './authenticator-sms.component.html',
  styleUrls: ['./authenticator-sms.component.scss'],
})
export class AuthenticatorSmsComponent  implements OnInit {

  @ViewChild(IonContent, {static: false}) content: IonContent;
  @Input() callback: () => void;
  error = null;
  verifiedCode: boolean;
  showMessageSMSSent: boolean;
  customer: CustomerModel;
  channels: string[];
  currentDisplayChannel: string;
  bypassPinSuccessUI = false; // it is by design in some case
  customerId;
  
  constructor(
    private userSessionService: UserSessionService,
    private authenticationService: AuthenticationService,
    private uniqueIDService: UniqueIDService,
    private navigator: Navigator,
    private configService: ConfigService,
    public successMessageService: SuccessMessageService
  ) {
    const mfaType = this.configService.getConfig().FEATURE_MFA_TYPE;
    const channels = this.configService.getConfig().FEATURE_MFA_CHANNELS as string;
    if(channels) {
      this.channels = channels.replace(/\s/g, '').split(','); //clean spaces in case configuration is not clean
    }
    if(!this.channels || this.channels.length == 0) {
      this.channels = ['SMS', 'EMAIL']; // default
    }

    if(mfaType && !this.channels.includes(mfaType)) {
      this.channels.push(mfaType);
    }
    this.currentDisplayChannel = mfaType ? mfaType : this.channels?.[0];
    this.userSessionService
      .getCustomer()
      .subscribe((customer: CustomerModel) => {
        if (customer) {
          this.customer = customer;
        }
      });
  }

  ngOnInit() {
    this.uniqueIDService.removeMFADeviceId();
    this.successMessageService.clearMessage();

    this.customerId = this.customer.customerId;

    this.authenticationService.sendLoginCode(this.customerId, this.currentDisplayChannel)
      .subscribe({
        next: response => {
          if (response.result == 1) {
            this.showMessageSMSSent = true;
          }
        },
        error: error => {
          switch (error.getErrorCode().toUpperCase()) {
            case 'SMS_FAILURE_CODE_SENT_BY_EMAIL':
              this.channels = ['EAMIL']
              this.currentDisplayChannel = 'EAMIL'
              this.showMessageSMSSent = true;
              this.error = null;  // do not set error
              return;
            case 'CUSTOMER_NOT_FOUND':
              error.setErrorMessage('Please login.');
              break;
            default:
              error.setErrorMessage(
                'An error has occured logging you in. Please try again.'
              );
              break;
          }
          this.error = error;
          this.content.scrollToTop(10);
        }
      });
  }

  closeModal = () => {
    this.navigator.dismissAll();
  };

  goToUpdatePhoneNumber() {
    this.navigator.navigateTo('UpdatePhoneNumberComponent',{forceModal: true},{navigationFromSMSCodePage: true, callback: this.callback} );
  }

  validateUserAction() {
    this.userSessionService.refreshCustomer();
    this.navigator.navigateTo("AuthenticatorChangeSuccessComponent");
  }

  onValidatePinError(event) {
    this.error = event;
    if (this.error) {
      this.content.scrollToTop(10);
    }
  }

  onUpdatePhoneNumber() {
    this.goToUpdatePhoneNumber();
  }

  onValidatePinSuccess() {
    this.verifiedCode = true;
    this.error = null;
  }

  onPinVerifiedUserAction() {
    this.validateUserAction();
  }

}
